export const META_PIXEL_ID = 'FznULiLZqoJjNfJWX7SmEF';

const track = (event, params) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', event, params || {});
  }
};

export const trackPageView = () => track('PageView');

// Lead: solo una vez por sesión (evita duplicado entre envío de formulario y thank-you)
export const trackLead = (params) => {
  if (sessionStorage.getItem('fbq_lead_tracked')) return;
  track('Lead', params);
  sessionStorage.setItem('fbq_lead_tracked', '1');
};

export const trackContact = (params) => track('Contact', params);
export const trackSchedule = (params) => track('Schedule', params);
export const trackPurchase = (params) => track('Purchase', params);
